"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var play_api_1 = require("@l2p/play-api");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
var useCalculatedBonus_1 = __importDefault(require("../Bonuses/useCalculatedBonus"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var react_html_parser_1 = __importDefault(require("react-html-parser"));
var AttentionIcon = function () { return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 36 36", "aria-hidden": "true", focusable: "false" },
    react_1.default.createElement("circle", { cx: 18, cy: 18, r: 16, fill: "none", stroke: "currentColor", strokeWidth: "1.4" }),
    react_1.default.createElement("line", { x1: 18, y1: 10, x2: 18, y2: 21, stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round" }),
    react_1.default.createElement("circle", { cx: 18, cy: 25, r: 1, fill: "currentColor" }))); };
var ProcessingTotalInfo = function (_a) {
    var _b, _c, _d, _e, _f;
    var _g = _a.fee, fee = _g === void 0 ? 0 : _g, totalAmount = _a.totalAmount, currency = _a.currency, children = _a.children, bonusesData = _a.bonusesData, _h = _a.methodMetadata, methodMetadata = _h === void 0 ? {} : _h;
    var t = (0, next_intl_1.useTranslations)('translation');
    var formState = (0, react_final_form_1.useFormState)();
    var form = (0, react_final_form_1.useForm)();
    var lang = (0, next_intl_1.useLocale)();
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    var _j = (0, useCalculatedBonus_1.default)(bonusesData, currency, formState), bonus = _j.bonus, bonusAmount = _j.bonusAmount;
    var lotteries = (0, swr_hooks_1.useLotteries)().data;
    var activeLottery = (0, react_1.useMemo)(function () {
        if (!lotteries)
            return null;
        return lotteries === null || lotteries === void 0 ? void 0 : lotteries.find(function (lottery) { return lottery.status === play_api_1.LotteryStatusEnum.Active; });
    }, [lotteries]);
    var ticketPrice = (0, react_1.useMemo)(function () {
        var _a, _b, _c;
        return (_c = (_b = (_a = activeLottery === null || activeLottery === void 0 ? void 0 : activeLottery.baseLottery) === null || _a === void 0 ? void 0 : _a.depositSettings) === null || _b === void 0 ? void 0 : _b.find(function (item) { return item.currency === currentCurrency; })) === null || _c === void 0 ? void 0 : _c.price;
    }, [currentCurrency, (_b = activeLottery === null || activeLottery === void 0 ? void 0 : activeLottery.baseLottery) === null || _b === void 0 ? void 0 : _b.depositSettings]);
    var minDepositAmount = (0, useCalculatedBonus_1.default)(bonusesData === null || bonusesData === void 0 ? void 0 : bonusesData.bonuses, currentCurrency, formState).minDepositAmount;
    var isSubmitButtonDisabled = (0, react_1.useMemo)(function () {
        var _a, _b;
        //@ts-ignore
        // const errorsCount = Object.keys(formState?.errors)?.length
        if (
        // !formState.touched ||
        (minDepositAmount && ((_a = formState === null || formState === void 0 ? void 0 : formState.values) === null || _a === void 0 ? void 0 : _a.amount) < minDepositAmount) ||
            ((_b = formState === null || formState === void 0 ? void 0 : formState.errors) === null || _b === void 0 ? void 0 : _b.amount)
        // errorsCount > 0
        )
            return true;
    }, [formState.errors, formState.values, minDepositAmount]);
    var isRequiredFieldsEmpty = (0, react_1.useMemo)(function () {
        var _a, _b;
        //@ts-ignore
        var errorsCount = (_a = Object.keys(formState === null || formState === void 0 ? void 0 : formState.errors)) === null || _a === void 0 ? void 0 : _a.length;
        var isAmountError = (_b = formState === null || formState === void 0 ? void 0 : formState.errors) === null || _b === void 0 ? void 0 : _b.amount;
        return isAmountError ? errorsCount > 1 : errorsCount > 0;
    }, [formState === null || formState === void 0 ? void 0 : formState.errors]);
    var isAmountValid = (_c = form.getFieldState('amount')) === null || _c === void 0 ? void 0 : _c.valid;
    var isChangedFieldsValid = (formState === null || formState === void 0 ? void 0 : formState.errors)
        ? !Object.entries(formState === null || formState === void 0 ? void 0 : formState.errors).filter(function (_a) {
            var field = _a[0];
            return field !== 'amount';
        })
            .length
        : false;
    var highlightedBlock = (0, react_1.useMemo)(function () {
        if (!isAmountValid) {
            return 'amount';
        }
        else if (!isChangedFieldsValid) {
            return 'fields';
        }
        else if (!isSubmitButtonDisabled) {
            return 'submit';
        }
        return 'amount';
    }, [isAmountValid, isChangedFieldsValid, isSubmitButtonDisabled]);
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat(highlightedBlock === 'submit' ? styles_module_scss_1.default.highlightedBlock : '') },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.bonus },
            react_1.default.createElement("span", null, t('yourBonus')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.bonusAmount }, bonus)),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.total },
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: styles_module_scss_1.default.fee }, t('processingFee')),
                currency && (react_1.default.createElement("div", { className: styles_module_scss_1.default.fee }, "".concat((0, apps_shared_1.getCurrencySymbol)(currency)).concat(fee)))),
            activeLottery && (react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: styles_module_scss_1.default.fee }, t('lotteryTickets')),
                currency && (react_1.default.createElement("div", { className: styles_module_scss_1.default.fee }, Math.floor((((_d = formState === null || formState === void 0 ? void 0 : formState.values) === null || _d === void 0 ? void 0 : _d.amount) || 1) / Number(ticketPrice || 1)))))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: styles_module_scss_1.default.text }, t('willBeReplenished')),
                react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.text) }, "".concat((0, apps_shared_1.getCurrencySymbol)(currency)).concat(Number(totalAmount || 0) + Number(bonusAmount || 0)))),
            ((_e = methodMetadata === null || methodMetadata === void 0 ? void 0 : methodMetadata['disclaimer']) === null || _e === void 0 ? void 0 : _e[lang]) ? (react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: styles_module_scss_1.default.disclaimer },
                    react_1.default.createElement(AttentionIcon, null),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.disclaimerText }, (0, react_html_parser_1.default)((_f = methodMetadata === null || methodMetadata === void 0 ? void 0 : methodMetadata['disclaimer']) === null || _f === void 0 ? void 0 : _f[lang]))))) : null),
        typeof children === 'function'
            ? children({
                minDepositAmount: minDepositAmount,
                isSubmitButtonDisabled: isSubmitButtonDisabled,
                isRequiredFieldsEmpty: isRequiredFieldsEmpty,
            })
            : children,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.supportButtonWrapper },
            react_1.default.createElement(ui_components_1.SupportButton, { text: t('needHelpQuestion') }))));
};
exports.default = ProcessingTotalInfo;
